<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col class="text-center">
          <h1 class="text-center">
            Add/Edit Test category for {{ typeObj.organization }}
          </h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card variant="dark" class="h-100">
            <form @submit.prevent="addType">
              <b-form-group>
                <b-form-group
                  class="nested-form-group"
                  label="Input Exam category Name"
                  label-for="institution"
                >
                  <b-form-input
                    type="text"
                    v-model="typeObj.category"
                    @focus="added = false"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Has Children Institution?">
                  <b-form-select v-model="typeObj.hasChildren">
                    <b-form-select-option value="null"
                      >--has Children?--</b-form-select-option
                    >
                    <b-form-select-option value="Yes">Yes</b-form-select-option>
                    <b-form-select-option value="No">No</b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group label="Has same Name?">
                  <span class="info-span"
                    >*Will this Exam Category has exactly same Name with its
                    Child Institution?</span
                  ><br />
                  <span class="info-span"
                    >*An Exam Category with Same Name as 'Yes' must have Only
                    one Child Institution Created!</span
                  >
                  <b-form-select v-model="typeObj.sameName">
                    <b-form-select-option value="null"
                      >--has same Name?--</b-form-select-option
                    >
                    <b-form-select-option value="Yes">Yes</b-form-select-option>
                    <b-form-select-option value="No">No</b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group label="Visibility? Who can see it?">
                  <b-form-select v-model="typeObj.visibility">
                    <b-form-select-option value="null"
                      >--Visibility?--</b-form-select-option
                    >
                    <b-form-select-option value="private"
                      >Private</b-form-select-option
                    >
                    <b-form-select-option value="public"
                      >Public</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  label="Children Nomenclature? e.g Papers, Institution, Exam Body"
                >
                  <b-form-input
                    type="text"
                    v-model="typeObj.childrenNomenclature"
                    @focus="added = false"
                  ></b-form-input>
                </b-form-group>
                <!-- {{  this.$route.path }} -->
                <div v-if="added" class="alert alert-success p-3">
                  Test Category Added
                </div>

                <div v-if="categoryupdated" class="alert alert-success p-3">
                  Test Category has been Updated Successfully
                </div>

                <div class="text-center">
                  <b-overlay
                    :show="proceeding || updating"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="w-100"
                  >
                    <b-button
                      v-if="!this.$route.params.trackid"
                      :disabled="substate"
                      type="submit"
                      class="w-50 p-2 btntxt"
                      variant="success"
                    >
                      Add Category
                    </b-button>

                    <b-button
                      v-if="this.$route.params.trackid"
                      :disabled="substate"
                      class="w-50 p-2 btntxt"
                      variant="warning"
                      @click="update"
                    >
                      Update
                    </b-button>
                  </b-overlay>

                  <b-button
                    v-if="proceeding"
                    class="w-50 p-2 mt-3 btntxt"
                    variant="dark"
                    @click="stopproceed"
                  >
                    Cancel
                  </b-button>
                </div>
              </b-form-group>
            </form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      chkcatarr: false,
      typeObj: this.getType(),
      proceeding: false,
      added: false,
      updating: false,
      categoryupdated : false
    };
  },
  created() {
    this.typeObj.organization = this.details.clearance_organization;
    this.typeObj.organization_id = this.details.clearance_organization_id;
  },
  async mounted() {
    if (!this.loggedin) {
      this.$router.push({
        name: "login"
      });
    }
    if (this.details.clearance == "Normal") {
      this.$router.push({
        name: "welcome"
      });
    }

    await this.fetchCategories();

    let trackid = this.$route.params.trackid;
    let editcategory = this.Categories.filter(x => x.track_id == trackid);
    // console.log(editcategory)

    if (this.$route.params.trackid) {
      this.typeObj = {
        trackid: this.$route.params.trackid,
        category: editcategory[0]?.name,
        organization: editcategory[0]?.organization_name,
        hasChildren: editcategory[0]?.hasChildren,
        childrenNomenclature: editcategory[0]?.children_nomenclature,
        sameName: editcategory[0]?.sameName,
        visibility: editcategory[0]?.visibility
      };
    }
  },
  methods: {
    ...mapActions("admin", ["setType", "fetchCategories", "updatecategory"]),

    addType() {
      this.proceeding = true;
      return this.setType(this.typeObj).then(() => {
        this.typeObj.category = "";
        this.typeObj.hasChildren = null;
        this.typeObj.childrenNomenclature = "";
        this.typeObj.sameName = null;
        this.proceeding = false;
        this.added = true;
      });
    },
    setloader() {
      this.updating = true;
    },
    setCategory() {
      this.setloader();
      this.sent = true;

      this.updatecategory(this.typeObj).then(() => {
        this.categoryupdated = true;
        this.updating = false;
        this.sent = false;
      });
    },
    update() {
      this.updating = true; // Set value of the data property 'updating' to true. This triggers the spinner to come up and also disables the updat button
      this.setCategory();
    },
    stopupdate() {
      this.updating = false; // If user clicks the cancel button, stops the spinner and enables the updat button.
    },
    getType() {
      return {
        category: "",
        organization: "",
        organization_id: "",
        hasChildren: null,
        sameName: null,
        childrenNomenclature: "Institution",
        visibility: "public",
        structure: "",
        adminname: this.$store.state.loginmaster.details.fullname,
        admintrackid: this.$store.state.loginmaster.details.trackid
      };
    },

    proceed() {
      this.proceeding = true; // Set value of the data property 'proceeding' to true. This triggers the spinner to come up and also disables the proceed button
    },
    stopproceed() {
      this.proceeding = false; // If user clicks the cancel button, stops the spinner and enables the proceed button.
    }
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      Categories: state => state.admin.Categories
    }),
    substate() {
      if (
        this.proceeding ||
        this.typeObj.category.length <= 0 ||
        this.typeObj.hasChildren == null ||
        this.typeObj.sameName == null ||
        this.typeObj.visibility == null ||
        this.typeObj.category.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.active-method {
  background-color: rgb(8, 8, 238);
}

.inactive-method {
  background-color: rgba(128, 128, 136, 0.74);
}
</style>
